import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapeUsoSustentavel');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryShapeUsoSustentavel = () => 
  axios.get(urlAPI + "/all/" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeUsoSustentavelInsideByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeUsoSustentavelIntersectsByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeUsoSustentavelInsideByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeUsoSustentavelIntersectsByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

